import { createApp } from 'vue';
import M4bToM4aConverter from '@/Components/M4bToM4aConverter.vue';
import '@styles/app.css';

createApp(M4bToM4aConverter).mount('#m4b-to-m4a-converter');
